import { createSelector } from "@ngrx/store";
import { AppState } from "@store/app.state";

const selectFeature = (state: AppState) => state.docViewer?.documentList;

export const currentDocListContext = createSelector(
    selectFeature,
    (state) => {
        return state;
    }
);

export const documentList = createSelector(
    selectFeature,
    (state) => {
        return state?.docList;
    }
);

export const isExpandedResults = createSelector(
    selectFeature,
    (state) => {
        return state?.isExpandedResults;
    }
);
